import { render, staticRenderFns } from "./ClientPaymentReminderPreference.vue?vue&type=template&id=ddcd9616"
import script from "./ClientPaymentReminderPreference.vue?vue&type=script&lang=js"
export * from "./ClientPaymentReminderPreference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports